export default {"src":"/_next/static/media/physics.6f256ce1.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};